import { webApiClient } from 'Shared/web_api_client';

onDomReady(async () => {
   if (window.App.siteName != 'ifixit') {
      return;
   }

   const client = await webApiClient();
   const bannerHtml = await client.get(`internal/guide_banner/${App.guideid}`, {
      statName: 'guide-banner',
   });
   const bannerContainer = document.querySelector('.js-guide-promo-banner-container');
   if (bannerContainer) {
      bannerContainer.innerHTML = bannerHtml ?? '';
   }
});
